import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0092bc",
    },
    arrowIcon: {
      main: "#fff",
    },
    button: {
      main: {
        active: {
          // background: "#ffbc0d",
          // text: "#000",
        },
      },
      details: {
        normal: {
          text: "#fff",
        },
        active: {
          background: "#8082857d",
          // text: "#000"
        },
      },
    },
    text: {
      primary: "#333",
      main: "#fff",
      light: "#B69A81",
      tableItems: {
        main: "#A8A8AA",
        highlight: "#fff",
      },
      title: "#0092bc",
    },
    background: {
      main: "#fff",
      details: {
        main: "#454f57",
        highlight: "#808285",
      },
    },
  },
  typography: {
    fontFamily: "Nunito Sans,Arial,sans-serif",
    h3: {
      fontWeight: 600,
      fontSize: "2.5rem",
      lineHeight: "2.75rem",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 787,
      md: 1024,
      lg: 1200,
      xl: 1536,
    },
  },
});

export default theme;
